export const environment = {
  cacheDuration: 3600,
  defaultLang: navigator.language,
  unitedLang: 'en-001',
  envName: 'prod',
  production: true,
  apiUrl: 'https://api.decathlon.net/nexchange_api/api/',
  key: '0ba4deb6-3f82-4ae3-bc66-f2bc909bc989',
  frontUrl: 'https://decathlon-exchange.decathlon.com/',
  mediaUrl: 'https://storage.googleapis.com/exchange-v2-prod/media/',
  classroomUrl: 'https://classroom.decathlon.com',
  availableLanguages: ['ar', 'de', 'en', 'en-IN', 'es', 'fr', 'hi', 'it', 'ru', 'vi', 'zh-CN', 'zh-TW'],
  authorizationRedirectUrl: 'https://admin-exchange.decathlon.net/',
  silentRefreshRedirectUri: 'https://admin-exchange.decathlon.net/silent-refresh.html',
  oauthConfig: {
    production: true,
    stsAuthority: 'https://idpdecathlon.oxylane.com',
    clientId: 'Cb20bf0e719fe2586be5e539bb6eef809caa4e263',
    clientRoot: window.location.origin,
    clientScope: 'openid profile',
  },
  datadog: {
    applicationId: 'fb3afb8e-8677-4524-a730-cc3a1663a225',
    clientToken: 'pubd8f63885e704edf5647d2d18560f7174',
    site: 'datadoghq.eu',
    env: 'production',
    version: 'master-202607080847-c5d03b8',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
  },
  google: {
    key: 'AIzaSyAcWw1WmZQPdhVaEr0tpDBPLS1E4-eaR4U',
    clientId: '395093854716-qeol93gd7u227blbb1t1302fk202ds6k.apps.googleusercontent.com',
    appId: '395093854716',
  },
  daPresential: {
    url: 'https://api-eu.decathlon.net/academy/presential/api/v1/',
    key: 'e156a2a1-e95b-4d16-953d-fb9745128181',
  },
  ldap: {
    url: 'https://api-eu.decathlon.net/directory/v1/',
    key: '446b753c-523d-4cba-b41f-4085ebd31a29',
  },
  searchApi: {
    url: 'https://api-eu.decathlon.net/search-api/v1/',
    key: '33cfd0b8-3249-4738-b8ae-3e4c5e4e6671',
  },
  s3Client: 'https://storage.cloud.google.com/exchange-v2-prod/',
  myGoogle: {
    url: 'https://api-eu.decathlon.net/mygoogleV2/api/v1/',
    key: 'e118e3e5-6c6d-403b-98e3-e56c6d603b70',
  },
  daTranslationsApi: {
    url: 'https://api-eu.decathlon.net/academy/translations/',
    key: 'e156a2a1-e95b-4d16-953d-fb9745128181',
  },
  hrSkillsReferentialV2: {
    url: 'https://api.decathlon.net/hr_repository_api/api/v1/',
    key: 'd2ecab7c-63c5-4311-9a25-be9e0778d309',
  },
  masterSport: {
    url: 'https://api-eu.preprod.decathlon.net/dictionaries/',
    key: '3a278384-97e6-47bc-8d13-59a36caee852',
  },
  phrase: {
    url: 'https://api.phrase.com/v2/projects/8fc2dc7541638cb97edbb42246d1f329/',
    token: 'token ' + '68f26bdfcedacb3e2662996fcc3c393c5997ece72c6c699fe78b2e47ebad53b3',
  },
  maintenanceMode: false,
  maintenanceEmails: [],
  bealink: 'https://university.decathlon.com/',
};
